import axios from 'axios';

// 设置 API 的基础 URL
axios.defaults.baseURL = import.meta.env.VITE_API_BASE_URL;

// 请求拦截器
axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 响应拦截器
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default axios;

// 获取期权持仓列表
// params 支持以下参数：
// - symbol: 标的代码
// - status: 持仓状态（OPEN/PARTIAL_CLOSED/CLOSED）
// - date: 日期
// - strategy: 策略（BREAKOUT/DOOMSDAY/CUSTOM）
export const getPositions = async (params) => {
    const response = await axios.get('/api/positions', { params });
    return response.data;
};

// 获取期权交易历史
export const getTradeHistory = async (positionId) => {
    const response = await axios.get(`/api/positions/${positionId}/history`);
    return response.data;
};

// 更新期权持仓止损价格
export const updateStopLossPrice = async (positionId, stopLossPrice) => {
    try {
        const response = await axios.put(`/api/positions/${positionId}/stop-loss`, {
            stop_loss_price: stopLossPrice
        });
        return response.data;
    } catch (error) {
        console.error('更新止损价格失败:', error.response?.data || error);
        throw error;
    }
};

// 获取止损监控列表
export const getStopLossMonitors = async () => {
    try {
        console.log('调用API获取止损监控列表...');
        const response = await axios.get('/api/stop-loss-monitors');
        console.log('止损监控列表API响应:', response);

        // 后端返回的字段与前端显示的字段映射
        // 确保字段名称与数据库表结构一致
        // stock_price: 股票价格
        // target_price: 目标价格
        // position_type: 仓位类型
        // status: 状态
        return response.data;
    } catch (error) {
        console.error('获取止损监控列表失败:', error.response?.data || error);
        console.error('错误详情:', error);
        throw error;
    }
};

// 更新止损监控目标价格
export const updateStopLossMonitorPrice = async (monitorId, targetPrice) => {
    try {
        const response = await axios.put(`/api/stop-loss-monitors/${monitorId}`, {
            target_price: targetPrice
        });
        return response.data;
    } catch (error) {
        console.error('更新止损监控价格失败:', error.response?.data || error);
        throw error;
    }
};

// 获取所有交易记录
export const getAllTrades = async (params) => {
    const response = await axios.get('/api/trades', { params });
    return response.data;
};

// 一键清仓所有持仓
export const closeAllPositions = async () => {
    const response = await axios.post('/api/positions/close-all');
    return response.data;
};
